import { useEffect } from 'react';
import { useLiveQuery } from 'dexie-react-hooks';
import { db } from '@/lib/db';
import { startSync } from './outbox';

/** Cuantos cambios quedan por subir. 0 = todo al dia. */
export function usePendingSyncCount(): number {
  return useLiveQuery(() => db.outbox.count(), [], 0) ?? 0;
}

/** Arranca el ciclo de sincronizacion mientras la app este montada. */
export function useSyncLoop(): void {
  useEffect(() => startSync(), []);
}
